"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSynthesize;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

var _createNativeUtterance = _interopRequireDefault(require("./createNativeUtterance"));

function useSynthesize() {
  var _useContext = (0, _react.useContext)(_Context["default"]),
      ponyfill = _useContext.ponyfill,
      synthesize = _useContext.synthesize;

  return function (utteranceOrText, progressFn) {
    if (typeof utteranceOrText === 'string') {
      utteranceOrText = (0, _createNativeUtterance["default"])(ponyfill, {
        text: utteranceOrText
      });
    }

    return synthesize(ponyfill, utteranceOrText, {
      onStart: progressFn && function () {
        return progressFn();
      }
    });
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VTeW50aGVzaXplLmpzIl0sIm5hbWVzIjpbInVzZVN5bnRoZXNpemUiLCJDb250ZXh0IiwicG9ueWZpbGwiLCJzeW50aGVzaXplIiwidXR0ZXJhbmNlT3JUZXh0IiwicHJvZ3Jlc3NGbiIsInRleHQiLCJvblN0YXJ0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7QUFFZSxTQUFTQSxhQUFULEdBQXlCO0FBQUEsb0JBQ0wsdUJBQVdDLG1CQUFYLENBREs7QUFBQSxNQUM5QkMsUUFEOEIsZUFDOUJBLFFBRDhCO0FBQUEsTUFDcEJDLFVBRG9CLGVBQ3BCQSxVQURvQjs7QUFHdEMsU0FBTyxVQUFDQyxlQUFELEVBQWtCQyxVQUFsQixFQUFpQztBQUN0QyxRQUFJLE9BQU9ELGVBQVAsS0FBMkIsUUFBL0IsRUFBeUM7QUFDdkNBLE1BQUFBLGVBQWUsR0FBRyx1Q0FBc0JGLFFBQXRCLEVBQWdDO0FBQUVJLFFBQUFBLElBQUksRUFBRUY7QUFBUixPQUFoQyxDQUFsQjtBQUNEOztBQUVELFdBQU9ELFVBQVUsQ0FBQ0QsUUFBRCxFQUFXRSxlQUFYLEVBQTRCO0FBQUVHLE1BQUFBLE9BQU8sRUFBRUYsVUFBVSxJQUFLO0FBQUEsZUFBTUEsVUFBVSxFQUFoQjtBQUFBO0FBQTFCLEtBQTVCLENBQWpCO0FBQ0QsR0FORDtBQU9EIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IENvbnRleHQgZnJvbSAnLi9Db250ZXh0JztcbmltcG9ydCBjcmVhdGVOYXRpdmVVdHRlcmFuY2UgZnJvbSAnLi9jcmVhdGVOYXRpdmVVdHRlcmFuY2UnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTeW50aGVzaXplKCkge1xuICBjb25zdCB7IHBvbnlmaWxsLCBzeW50aGVzaXplIH0gPSB1c2VDb250ZXh0KENvbnRleHQpO1xuXG4gIHJldHVybiAodXR0ZXJhbmNlT3JUZXh0LCBwcm9ncmVzc0ZuKSA9PiB7XG4gICAgaWYgKHR5cGVvZiB1dHRlcmFuY2VPclRleHQgPT09ICdzdHJpbmcnKSB7XG4gICAgICB1dHRlcmFuY2VPclRleHQgPSBjcmVhdGVOYXRpdmVVdHRlcmFuY2UocG9ueWZpbGwsIHsgdGV4dDogdXR0ZXJhbmNlT3JUZXh0IH0pO1xuICAgIH1cblxuICAgIHJldHVybiBzeW50aGVzaXplKHBvbnlmaWxsLCB1dHRlcmFuY2VPclRleHQsIHsgb25TdGFydDogcHJvZ3Jlc3NGbiAmJiAoKCkgPT4gcHJvZ3Jlc3NGbigpKSB9KTtcbiAgfTtcbn1cbiJdfQ==